import { z } from "zod";
import { PageBlockDefinitionAppearance } from "./aux";
import { PageBlockDefinitionItem } from "./item";

//
// Enums
//

export const PageBlockCategory = z.enum([
  "Text",
  "Layout",
  "Media",
  "Embed",
  "Figma",
  "Code",
  "Guidelines",
  "Tokens",
  "Components",
  "Assets",
  "Data",
  "Other",
]);

export const PageBlockBehaviorDataType = z.enum([
  "Item",
  "Token",
  "Asset",
  "Component",
  "FigmaNode",
  "FigmaComponent",
  "File",
]);

export const PageBlockBehaviorSelectionType = z.enum(["Entity", "Group", "EntityAndGroup"]);

export type PageBlockCategory = z.infer<typeof PageBlockCategory>;
export type PageBlockBehaviorDataType = z.infer<typeof PageBlockBehaviorDataType>;
export type PageBlockBehaviorSelectionType = z.infer<typeof PageBlockBehaviorSelectionType>;

//
// Definitions
//

export const PageBlockDefinitionBehavior = z.object({
  dataType: PageBlockBehaviorDataType,
  items: z
    .object({
      numberOfItems: z.number(),
      allowLinks: z.boolean(),
      newItemLabel: z.string().optional(),
    })
    .optional(),
  entities: z
    .object({
      selectionType: PageBlockBehaviorSelectionType,
      maxSelected: z.number(),
    })
    .optional(),
});

export const PageBlockDefinitionOnboarding = z.object({
  helpText: z.string(),
  documentationLink: z.string().optional(),
});

export const PageBlockDefinition = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string(),
  category: PageBlockCategory,
  icon: z.string().optional(),
  documentationLink: z.string().optional(),
  searchKeywords: z.array(z.string()).optional(),
  item: PageBlockDefinitionItem,
  behavior: PageBlockDefinitionBehavior,
  editorOptions: z.object({
    onboarding: PageBlockDefinitionOnboarding.optional(),
    newItemLabel: z.string().optional(),
  }),
  appearance: PageBlockDefinitionAppearance.optional(),
});

export type PageBlockDefinitionBehavior = z.infer<typeof PageBlockDefinitionBehavior>;
export type PageBlockDefinitionOnboarding = z.infer<typeof PageBlockDefinitionOnboarding>;
export type PageBlockDefinition = z.infer<typeof PageBlockDefinition>;
